import { Pipe, PipeTransform } from "@angular/core";
import {
    AFIKIM_ICON,
    BET_SHEMESH_EXPRESS_ICON,
    CARMELIT_ICON,
    DAN_BEER_SHEVA_ICON,
    DAN_DROM_ICON,
    DAN_ICON,
    eAgencyNames,
    EGGED_DEREK_ICON,
    EGGED_ICON,
    EILOT_ICON,
    ELECTRA_AFIKIM_ICON,
    ES_BUSSES_ICON,
    EXTRA_ICON,
    GALIM_ICON,
    GB_TOURS_ICON,
    GOLAN_ICON,
    JERUSALEM_ABU_TOR_UNIFIED_ICON,
    JERUSALEM_ALLAWAST_UNIFIED_ICON,
    JERUSALEM_MOUNT_OF_OLIVES_ICON,
    JERUSALEM_RAMALLAH_UNIFIED_ICON,
    JERUSALEM_SOUTH_UNIFIED_ICON,
    JERUSALEM_SUR_BAHER_UNIFIED_ICON,
    KAVIM_ICON,
    KFIR_ICON,
    METRO_KAV_TAXI_ICON,
    METROPOLIN_ICON,
    NATIV_EXPRESS_ICON,
    ODELIA_TAXI_ICON,
    RAHBALIT_ICON,
    RIDES_AND_TOURS_ICON,
    SHAM_ICON,
    SUPER_BUS_ICON,
    TEVEL_ICON,
    TNUFA_ICON,
    TRAIN_ICON,
    UNITED_TOURS_ICON,
    DAN_NETIVIM_ICON
} from "../constants/agencies.constants";

@Pipe({
    name: 'agencyLogoByName',
    standalone: false
})
export class AgencyLogoByNamePipe implements PipeTransform {

    transform(agencyName: string): string {
        switch (agencyName) {
            case eAgencyNames.DAN:
                return DAN_ICON;
            case eAgencyNames.EGGED:
                return EGGED_ICON;
            case eAgencyNames.EGGED_DEREK:
                return EGGED_DEREK_ICON;
            case eAgencyNames.KAVIM:
                return KAVIM_ICON;
            case eAgencyNames.AFIKIM:
                return AFIKIM_ICON;
            case eAgencyNames.METROPOLIN:
                return METROPOLIN_ICON;
            case eAgencyNames.CARMELIT:
                return CARMELIT_ICON;
            case eAgencyNames.RAHBALIT:
                return RAHBALIT_ICON;
            case eAgencyNames.TEVEL:
                return TEVEL_ICON;
            case eAgencyNames.TRAIN:
                return TRAIN_ICON;
            case eAgencyNames.DAN_BEER_SHEVA:
                return DAN_BEER_SHEVA_ICON;
            case eAgencyNames.DAN_SOUTH:
                return DAN_DROM_ICON;
            case eAgencyNames.EILOT:
                return EILOT_ICON;
            case eAgencyNames.EXTRA:
                return EXTRA_ICON;
            case eAgencyNames.EXTRA_JERUSALEM:
                return EXTRA_ICON;
            case eAgencyNames.GALIM:
                return GALIM_ICON;
            case eAgencyNames.GB_TOURS:
                return GB_TOURS_ICON;
            case eAgencyNames.GOLAN:
                return GOLAN_ICON;
            case eAgencyNames.KFIR:
                return KFIR_ICON;
            case eAgencyNames.METRO_KAV_TAXI:
                return METRO_KAV_TAXI_ICON;
            case eAgencyNames.NATIV_EXPRESS:
                return NATIV_EXPRESS_ICON;
            case eAgencyNames.ODELIA_TAXI:
                return ODELIA_TAXI_ICON;
            case eAgencyNames.SHAM:
                return SHAM_ICON;
            case eAgencyNames.SUPERBUS:
                return SUPER_BUS_ICON;
            case eAgencyNames.TNUFA:
                return TNUFA_ICON;
            case eAgencyNames.UNITED_TOURS:
                return UNITED_TOURS_ICON;
            case eAgencyNames.JRUSALEM_RAMALLAH_UNIFIED:
                return JERUSALEM_RAMALLAH_UNIFIED_ICON;
            case eAgencyNames.JERUSALEM_ALLAWAST_UNIFIED:
                return JERUSALEM_ALLAWAST_UNIFIED_ICON;
            case eAgencyNames.RIDES_AND_TOURS:
                return RIDES_AND_TOURS_ICON;
            case eAgencyNames.BET_SHEMESH_EXPRESS:
                return BET_SHEMESH_EXPRESS_ICON;
            case eAgencyNames.ELECTRA_AFIKIM:
                return ELECTRA_AFIKIM_ICON;
            case eAgencyNames.JERUSALEM_ABU_TOR_UNIFIED:
                return JERUSALEM_ABU_TOR_UNIFIED_ICON;
            case eAgencyNames.JERUSALEM_MOUNT_OF_OLIVES:
                return JERUSALEM_MOUNT_OF_OLIVES_ICON;
            case eAgencyNames.ES_BUSSES:
                return ES_BUSSES_ICON;
            case eAgencyNames.JERUSALEM_SOUTH_UNIFIED:
                return JERUSALEM_SOUTH_UNIFIED_ICON;
            case eAgencyNames.JERUSALEM_SUR_BAHER_UNIFIED:
                return JERUSALEM_SUR_BAHER_UNIFIED_ICON;
            case eAgencyNames.DAN_NETIVIM:
                return DAN_NETIVIM_ICON;
            default:
                return "";
        }
    }

}